import { useState } from "react";
import { useNavigate } from "react-router-dom";

function LoginPage() {

const [email,setEmail] = useState("");
const [password,setPassword] = useState("");

const navigate = useNavigate();

const handleLogin = async (e) => {
e.preventDefault();

const res = await fetch("https://final-trace.onrender.com/api/auth/login",{
method:"POST",
headers:{
"Content-Type":"application/json"
},
body: JSON.stringify({
email,
password
})
});

const data = await res.json();

alert(data.message);

if(data.message === "Login successful"){
navigate("/dashboard");
}
};

return (

<div style={{
display:"flex",
justifyContent:"center",
alignItems:"center",
height:"100vh",
background:"linear-gradient(135deg,#1e3c72,#2a5298)"
}}>

<form onSubmit={handleLogin} style={{
background:"white",
padding:"40px",
borderRadius:"12px",
width:"340px",
boxShadow:"0 8px 20px rgba(0,0,0,0.2)"
}}>

<h2 style={{textAlign:"center", marginBottom:"20px"}}>
Login
</h2>

<input
type="email"
placeholder="Email"
value={email}
onChange={(e)=>setEmail(e.target.value)}
required
style={{
width:"100%",
padding:"10px",
marginTop:"10px",
borderRadius:"6px",
border:"1px solid #ccc"
}}
/>

<input
type="password"
placeholder="Password"
value={password}
onChange={(e)=>setPassword(e.target.value)}
required
style={{
width:"100%",
padding:"10px",
marginTop:"15px",
borderRadius:"6px",
border:"1px solid #ccc"
}}
/>

<button
type="submit"
style={{
width:"100%",
padding:"12px",
marginTop:"20px",
background:"#2a5298",
color:"white",
border:"none",
borderRadius:"6px",
cursor:"pointer",
fontWeight:"bold"
}}
>
Login
</button>

</form>

</div>

);

}

export default LoginPage;